import React from 'react'
import Header from './Header'
import Navbar from './Navbar'
import Footer from './Footer'
import BannerImage from './BannerImage'
import NewsMarquee from './NewsMarquee'
import { useLocation } from 'react-router-dom'

const Layout = ({ children }) => {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <div>
      <Header />
      <Navbar />
      <NewsMarquee />
      {!isHome && <BannerImage />}
      <div className="children-body">
        {children}
      </div>
      <Footer />
    </div>
  )
}

export default Layout
